module.exports = __webpack_public_path__ + "img/9788959524006.797d04e5.jpg";